import { render } from "./OpenIdSignIn.vue?vue&type=template&id=2de2ea3e&ts=true"
import script from "./OpenIdSignIn.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpenIdSignIn.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/OpenIdSignIn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2de2ea3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2de2ea3e', __exports__)) {
    api.reload('2de2ea3e', __exports__)
  }
  
  module.hot.accept("./OpenIdSignIn.vue?vue&type=template&id=2de2ea3e&ts=true", () => {
    api.rerender('2de2ea3e', render)
  })

}


export default __exports__